import React from 'react'
import classNames from 'classnames'
import { Link } from 'gatsby'
import { LocationsQuery, getStateName, StateProvider } from '../../core'

import './locations-by-state.scss'

const LocationBasic = ({ title, neighborhood, slug, comingSoon, href }) => {
  
  if (href) {
    return (
      <a styleName='location' href={href} target="_blank" rel="noopener noreferrer">
        {comingSoon && <p styleName="coming-soon">Coming Soon</p>}
        <p>{title}</p>
        <h5>{neighborhood}</h5>
      </a>
    )
  }
    
  return (
    <Link styleName='location' to={`/locations/${slug}`}>
      {comingSoon && <p styleName="coming-soon">Coming Soon</p>}
      <p>{title}</p>
      <h5>{neighborhood}</h5>
    </Link>
  )
}

const LocationContact = ({ address, email, phoneNumber }) => (
  <div styleName='location'>
    <p>
      {address.addressLine1}{address.addressLine2 && `, ${address.addressLine2}`}
      <br />
      {address.city}, {address.state} {address.zipCode}
    </p>
    {email && <p><a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">{email}</a></p>}
    {phoneNumber && <p><a href={`tel:${phoneNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer">{phoneNumber}</a></p>}
  </div>
)

class LocationsByState extends React.Component {
  render() {
    const { customLocations, display, theme } = this.props

    const getHref = pdf => {
      if (!pdf || display !== 'PDF') return null
      return pdf.file.url
    }

    return (
      <LocationsQuery 
        render={({ data }) => {
          const states = {}
          let count = 0

          data.locations.forEach(location => {
            if (
              customLocations 
               && !customLocations.find(custom => custom.id === location.id)
            ) {
              return
            }

            if (!location.address) return
            const { state } = location.address

            if (location.isActive) {
              states[state] = states[state] || { active: [], comingSoon: [] }
              states[state].active.push(location)
            } else {
              if (display !== 'PDF') {
                states[state] = states[state] || { active: [], comingSoon: [] }
                states[state].comingSoon.push(location)
              }
            }

            count += 1
          })

          const columns = count < 3 ? 1 : 3

          const Location = display === 'Contact'
            ? LocationContact
            : LocationBasic

          const wrapperClass = classNames(
            'all-states',
            theme && `theme-${theme}`
          )
          
          return (
            <div styleName={`${wrapperClass}`} style={{ columns }}>  
              {Object.keys(states)
                .sort()
                .map((state, i )=> (
                  <StateProvider key={i}>{(isExpanded, setExpanded) => {
                    const locationsClass = classNames(
                      'locations',
                      isExpanded && 'is-expanded'
                    )
                  
                    const stateNameClass = classNames(
                      'state-name',
                      isExpanded && 'is-expanded'
                    )

                    return (
                      <div styleName='state'>
                        <h5 styleName={`${stateNameClass}`} onClick={() => setExpanded(!isExpanded)}>
                          <b>{getStateName(state)}</b>
                        </h5>

                        <div styleName={`${locationsClass}`}>
                          {states[state].active.map(({ id, locationPDF, ...rest }) => (
                            <Location key={id} {...rest} href={getHref(locationPDF)} />
                          ))}

                          {states[state].comingSoon.map(({ id, locationPDF, ...rest }) => (
                            <Location key={id} {...rest} href={getHref(locationPDF)} comingSoon={true} />
                          ))}
                        </div>
                      </div>
                    )
                  }}</StateProvider>
                ))}
            </div>
          )
        }}
      />
    )
  }
}

export default LocationsByState